/**
 * Auth API — server-mediated OTP send/confirm.
 *
 * These two endpoints are gated by the signup access code on the server
 * (see `production/api/src/services/signup/service.ts`). Session
 * lifetime (refresh, persistence, cross-tab coordination) is owned by
 * the Supabase SDK on the client — see `auth/supabase-client.ts` and
 * `auth/auth-adapter.ts`. There is intentionally no `/refresh` route on
 * our API: refresh tokens already prove identity, so there's nothing
 * the access-code gate would add, and proxying through us re-introduces
 * the failure modes that PR #172's hand-rolled refresh path created.
 *
 * NOTE: `credentials: "include"` matters here even though these endpoints are
 * "pre-login" from Supabase's perspective. The staging API hostnames sit behind
 * Cloudflare Zero Trust Access, which checks the `CF_Authorization` cookie on
 * *every* request — including this one. Without `credentials: "include"`, the
 * cookie is stripped on the cross-origin call from localhost, Access 302s to
 * its login page, and the SPA sees a CORS error before send-otp ever reaches
 * the worker. Production (`api.putty.me`) has no Access in front of it, so the
 * option is harmless there. See the longer note in `base-query-api.ts` for the
 * full rationale.
 */
import { API_BASE_URL } from "@/viewer-config";
async function authFetch(path, body) {
    return fetch(`${API_BASE_URL}/v1/auth${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        credentials: "include",
    });
}
export async function sendOtp(options) {
    const res = await authFetch("/send-otp", options);
    if (!res.ok) {
        const body = (await res.json().catch(() => ({ error: "UNKNOWN", message: "Unknown error" })));
        throw { ...body, status: res.status };
    }
}
export async function confirmOtp(options) {
    const res = await authFetch("/confirm-otp", options);
    if (!res.ok) {
        const body = (await res.json().catch(() => ({ error: "UNKNOWN", message: "Unknown error" })));
        throw { ...body, status: res.status };
    }
    return (await res.json());
}
